import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    transform: [{ rotate: '4.8deg' }],
  },

  text: {
    position: 'absolute',
    color: '#ffffff',
    fontFamily: 'Montserrat_500Medium',
  },
});
